
//Namespaced global variables for tracking client data
//For example the current program being viewed, my user id etc
//These are populated in django templates

if(mantl == undefined){
    mantl = {};
}
//mantl.something = "test";

//Role Constants
mantl.roles = [
    "primary_owner",//0
    "owner",//1
    "admin",//2
    "member",//3
    "mentor",//4
    "learner",//5
    "guest_contributor"//6
];

mantl.s3 = {
    dev: "https://mymantldev.s3.amazonaws.com/",
    prod: "https://mymantl.s3.amazonaws.com/"
}

// export default mantl;

//TODO: fix/unify the events in the various JS files to be namespaced under mantl
